import {
  Component,
  OnInit,
  Input,
  ViewChild,
  ComponentFactoryResolver,
  EventEmitter,
} from "@angular/core";
import { ComponentLoaderDirective } from "./core/directives/component-loader.directive";
import { LoadableComponent } from "./core/interfaces/loadable-component";

@Component({
  selector: "app-component-loader",
  templateUrl: "./component-loader.component.html",
  styleUrls: ["./component-loader.component.scss"],
})
export class ComponentLoaderComponent implements OnInit {
  @Input() component!: LoadableComponent;
  @ViewChild(ComponentLoaderDirective, { static: true })
  componentLoader!: ComponentLoaderDirective;

  constructor(private componentFactoryResolver: ComponentFactoryResolver) {}

  ngOnInit(): void {
    this.loadComponent();
  }

  loadComponent(): void {
    this.renderComponent();
  }

  renderComponent() {
    if (!this.component?.component) {
      return;
    }
    const componentFactory =
      this.componentFactoryResolver.resolveComponentFactory(
        this.component.component
      );

    const viewContainerRef = this.componentLoader.viewContainerRef;
    viewContainerRef.clear();

    var componentRef = viewContainerRef.createComponent<any>(componentFactory);
    this.bindComponentParams(componentRef);
    this.bindComponentOutputs(componentRef);
  }

  bindComponentParams(componentRef: any) {
    if (!this.component.params) return;
    for (let param of Object.keys(this.component.params)) {
      componentRef.instance[param] = this.component.params[param];
    }
  }

  bindComponentOutputs(componentRef: any) {
    if (!this.component.outputs) return;
    for (let outputName of Object.keys(this.component.outputs)) {
      if (componentRef.instance[outputName] instanceof EventEmitter) {
        componentRef.instance[outputName].subscribe(
          this.component.outputs[outputName]
        );
      }
    }
  }
}
